<template>
    <div>
        <div v-for="message in okMessages" class="uk-container">
            <div uk-alert class="uk-alert-primary" role="alert">
                <a class="uk-alert-close" uk-close></a>
                {{ message }}
            </div>
        </div>
        <div v-for="message in alertMessages" class="uk-container">
            <div uk-alert class="uk-alert-danger" role="alert">
                <a class="uk-alert-close" uk-close></a>
                {{ message }}
            </div>
        </div>
    </div>
</template>

<script>
    import EventBus from "../events.js";
    export default {
        name: "UserMessages",

        components: {
            EventBus
        },

        data() {
            return {
                okMessages:[],
                alertMessages:[]
            };
        },

        mounted() {
            EventBus.addEventListener("message", (message) => this.addMessage(message));
            EventBus.addEventListener("error", (message) => this.addError(message));
        },

        methods: {
            addMessage(message){
                this.okMessages.push(message);
            },
            addError(message){
                this.alertMessages.push(message);
            }
        }
    }
</script>
